export default "__VITE_ASSET__2d9b57be__"